import { render, staticRenderFns } from "./templatemessage.vue?vue&type=template&id=f2abb25e&"
import script from "./templatemessage.vue?vue&type=script&lang=ts&"
export * from "./templatemessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports